import { useParams } from "react-router";
import { useVbsWorkOrderShowQuery } from "@/services/backend/vbs/work-orders/api/work-order-api";
import { TreatmentComponent } from "@/services/backend/vbs/treatments/components/treatment-component";
import { Column } from "@/services/backend/vbs/treatments/lib/treatment-component-state";

export function WorkOrderPlanningTreatmentRoute() {
  const { workOrderId } = useParams();
  const { data } = useVbsWorkOrderShowQuery({ id: workOrderId! });

  return (
    <TreatmentComponent
      treatmentId={data!.treatmentId}
      defaultColumns={[
        Column.Position,
        Column.ComponentKind,
        Column.ComponentData,
        Column.Cycle,
        Column.CleanTime,
        Column.Comment,
        Column.Actions,
      ]}
    />
  );
}
